import React, { useState } from "react";
import HomeDashboardLayout from "../homeDashboard/HomeDashboardLayout";
import HeaderProfileSection from "../homeDashboard/HeaderProfileSection";
import "../dashboard/Dashboard.css";
import LanguageIcon from "../assets/images/App-Language.png";

//Import SVg
import { LanguageMobileIcon, BackSVG } from "../components/SvgIcons";

const AppLanguage = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("english");

  const languages = [
    {
      id: "english",
      label: "English",
      translation: "English",
    },
    {
      id: "hindi",
      label: "\u0939\u093f\u0902\u0926\u0940",
      translation: "Hindi",
    },
  ];

  return (
    <>
      <style>{`
        .page-content {
          background: #fff;
        }

        body {
          background: #fff !important;
        }

        @media (max-width: 767px) {
          .headerDash {
            display: none;
          }

          .layout-wrapper .main-content {
            padding-top: 0px !important;
          }
        }
      `}</style>
      <HomeDashboardLayout showHeader={false}>
          <div className="qbankList-page page-padding">
          <div className="qbl-main">
            {/* <section className="qbl-panel"> */}
              {/* Page Header */}
              <div className="hideProfile-page">
                <div className="categories-page-header mb-0">
                  <div>
                    <button
                      type="button"
                      className="categories-back-button"
                      onClick={() => window.history.back()}
                      aria-label="Go back"
                    >
                      <i className="bi bi-chevron-left"></i>
                    </button>
                  </div>

                  <div></div>

                  <div>
                    <HeaderProfileSection />
                  </div>
                </div>
              </div>
        {/* <div className="d-flex justify-content-between align-items-center d-md-none header-Mobile">
          <div className="languageImg d-flex d-md-none">
            <BackSVG />
          </div>
          <h4 className="fw-bold mb-0"> Choose App Language </h4>
          <div className="languageImg d-flex d-md-none">
           
          </div>
        </div> */}
            {/* Page Title */}
          <div className="qb-wrapper content-language">
            <div className="qb-body">
              <div className="d-flex align-items-center justify-content-center mt-2">
                <div className="qb-copy">
                  <h1 className="qb-title">
                   Choose App  <span>Language</span>
                  </h1>
                  {/* <p className="qb-sub qbb-list">
                      Select your preferred content language. This will determine the
                      language in which articles, videos, and other in-app content
                      are shown.
                  </p> */}
                </div>
               </div>
            </div>

         <div className="qb-wrapper app-language change-pwd">
            <div className="app-language__content text-center">
              <div className="pwd-img text-center">
                <img src={LanguageIcon} alt="" />
              </div>
              <p className="languageText grayText">
                  Select your preferred language to continue using the app in the
                  way that feels most comfortable to you. You can change the
                  language anytime later in the app settings.
              </p>

            <form className="app-language__list" aria-label="App language">
              {languages.map((language) => (
                <label key={language.id} className="app-language__option">
                  <input
                    type="radio"
                    name="app-language"
                    value={language.id}
                    checked={selectedLanguage === language.id}
                    onChange={() => setSelectedLanguage(language.id)}
                  />
                  <span className="app-language__option-content">
                    <span className="app-language__option-text">
                      <span className="app-language__label blackText">{language.label}</span>
                      <span className="app-language__translation text-purple">{language.translation}</span>
                    </span>
                    <span className="app-language__radio" aria-hidden="true">
                    </span>
                  </span>
                </label>
              ))}
            </form>
          </div>
        </div>
        </div>
        </div></div>
      </HomeDashboardLayout>
    </>
  );
};

export default AppLanguage;
